import React from 'react'
import { RealEstateCategory, SegmentationType, TransactionType } from '../../../../../@types/types'
import { Flow, FlowName, FlowScreenElement } from '../../../../../@types/flow-types'
import { TENANT_HANGAR_RENT_FLOW_PATH } from '../../../../../services/routes/routes'
import { tenantHangarRentSchema } from './tenantHangarRentSchema'
import {
  SCREEN_ADDRESS,
  SCREEN_CONNECTIONS,
  SCREEN_CONTACT_INFO,
  SCREEN_COSTS,
  SCREEN_DESCRIPTION,
  SCREEN_MULTIMEDIA,
  SCREENS,
} from '../../../../../services/domain/wizardScreens'
import ContactInfo from '../../../../../components/pages/insertionPage/screens/contactInfo/ContactInfo'
import Address from '../../../../../components/pages/insertionPage/screens/address/Address'
import Multimedia from '../../../../../components/pages/insertionPage/screens/multimediaNew/Multimedia'

import { MultimediaUploaderType } from '../../../../../@types/multimedia-types'
import CommercialCostsRent from '../../../../../components/pages/insertionPage/screens/costs/wrappers/commercial/CommercialCostsRent'
import Description from '../../../../../components/pages/insertionPage/screens/description/Description'
import {
  hangarOtherFacilitiesScreen,
  hangarRentBasicInfoScreen,
} from '../../propertyOwner/hangar/propertyOwnerHangarRentFlow'
import Connections from '../../../../../components/pages/insertionPage/screens/connections/Connections'

const tenantHangarRentFlowScreens: FlowScreenElement[] = [
  {
    screen: SCREENS[SCREEN_ADDRESS],
    element: (props) => <Address {...props} />,
  },
  hangarRentBasicInfoScreen,
  {
    screen: SCREENS[SCREEN_COSTS],
    element: (props) => (
      <CommercialCostsRent {...props} hasMoveInDate={true} screenTooltipKey='tooltip.screens.costs.allRent' />
    ),
  },
  {
    screen: SCREENS[SCREEN_DESCRIPTION],
    element: (props) => <Description {...props} hasLocationNote={true} />,
  },
  {
    screen: SCREENS[SCREEN_MULTIMEDIA],
    element: (props) => (
      <Multimedia
        {...props}
        doCloseMultimediaStatusMessage={props.doCloseMultimediaStatusMessage!}
        allowedTypesToDisplay={[MultimediaUploaderType.PICTURE, MultimediaUploaderType.VIDEO]}
      />
    ),
  },
  hangarOtherFacilitiesScreen,
  {
    screen: SCREENS[SCREEN_CONNECTIONS],
    element: (props) => <Connections {...props} />,
  },
  {
    screen: SCREENS[SCREEN_CONTACT_INFO],
    element: (props) => <ContactInfo {...props} />,
  },
]

export const tenantHangarRentFlow: Flow = {
  flowInformation: {
    owner: 'wizard.navigation.header.tenant',
    estateType: 'wizard.navigation.header.hangar',
    path: TENANT_HANGAR_RENT_FLOW_PATH,
    name: FlowName.TENANT_HANGAR_RENT,
    validationSchema: tenantHangarRentSchema,
    metaData: {
      category: RealEstateCategory.PRODUCTION_HALL,
      segmentation: SegmentationType.TENANT,
      transaction: TransactionType.RENT,
    },
  },
  defaultStateValues: {
    hideStreetAndStreetNumber: false,
  },
  flowScreens: tenantHangarRentFlowScreens,
}
